<template>
  <div class="main_center">
    <div class="content">

      <el-form ref="form" :model="form" label-width="100px">
        <el-row>
          <el-col :span="7">
            <el-form-item label="年份：" >
              <el-select v-model="form.year" value-key="value" style="width:100%;"  @change="yearsChange">
                <el-option v-for="(item,index) in yearsList"
                           :key="index"
                           :label="item"
                           :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7" :offset="1" >
            <el-form-item label="项目编号：">
              <el-input v-model="form.tenderProjectCode" clearable @keydown.enter.native.stop="getDataList"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="1" v-if="moreSearchItem">
            <el-form-item label="项目名称：">
                <el-input v-model="form.tenderProjectName" clearable @keydown.enter.native.stop="getDataList"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" v-if="moreSearchItem">
              <el-form-item label="所属机构：">
                  <el-input v-model="form.orgName" clearable @keydown.enter.native.stop="getDataList"></el-input>
              </el-form-item>
          </el-col>
          <div style="float:right;">
            <el-button size="mini" type="text" v-if="!moreSearchItem" @click="moreSearchItem = true" icon="el-icon-arrow-down">展开</el-button>
            <el-button size="mini" type="text" v-if="moreSearchItem" @click="moreSearchItem = false" icon="el-icon-arrow-up">收起</el-button>
            <el-button @click="searchBtn" size="small" type="primary">搜索</el-button>
            <el-button @click="refresh" plain size="small" type="primary">重置</el-button>
          </div>
        </el-row>
      </el-form>
      <el-table :data="tableData"
                v-loading="dataListLoading"
                ref="multipleTable"
                :height="tableMaxHeight"
                stripe border
                @selection-change="handleSelectionChange">
        <el-table-column fixed label="序号" type="index" :index="indexMethod" width="50" align="center"
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button type="text" title="查看" v-if="hasBtnPermission('btn_jz_tradding_actives_show')" @click="router(scope.row,false)">查看</el-button>
            <el-button type="text" title="修改" v-if="hasBtnPermission('btn_jz_tradding_actives_updateEntry')" @click="router(scope.row,true)">修改</el-button>
<!--            <el-button type="text" title="删除"  @click="deleteById(scope.row)">删除</el-button>-->
          </template>
        </el-table-column>
          <el-table-column label="项目编号" prop='tenderProjectCode' header-align="center" align="center" min-width='100'
                           :show-overflow-tooltip='true'></el-table-column>

        <el-table-column label="项目名称" prop='tenderProjectName' header-align="center" align="left" min-width='100'
                         :show-overflow-tooltip='true'></el-table-column>

        <el-table-column label="开标时间" prop='bidopenTime' header-align="center" align="center" min-width='100'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="所属机构" prop='orgName' header-align="center" align="center" min-width='100'
                         :show-overflow-tooltip='true'>
        </el-table-column>
      </el-table>
      <el-pagination background
                     layout="total, sizes, prev, pager, next"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="pageSize"
                     :total="total"
                     :current-page="pageIndex"
                     @size-change="sizeChangeHandle"
                     @current-change="currentChangeHandle"></el-pagination>
    </div>
  </div>
</template>

<script>
    import {mapState} from "vuex";
    import {nearSixYearsList} from '@/utils/index';
    // import {removeTabHandle} from '@/utils/routeTab';

    export default {
  data() {
    return {
      tableMaxHeight: document.documentElement.clientHeight - 234,
      dataListLoading: false,
      moreSearchItem:false,
      yearsList:[],
      form: {
          year:new Date().getFullYear(),
          search:'' ,//搜索框的值
          tenderProjectCode:"",
          tenderProjectName:"",
          orgName:"",
      },
      checkList1: '',
      pageSize: 10,//每页条数
      pageIndex: 1,//当前页
      total: 0,//总条数
      tableData: [],
      multipleSelection: [],
      user: '', //角色类型
      formData: {},
    }
  },
  computed: {
    ...mapState({
      stateData: state => state.user
    }),
  },
  filters: {
    ellipsis(text, num) {
      if (text.length > num) {
        return text.substring(0, num) + '...';
      } else {
        return text;
      }
    },
  },
  created() {
    this.yearsList = nearSixYearsList(this.form.year)
  },
  activated() {
    // this.refresh();
    this.getDataList()
  },
  mounted() {
    const that = this;
    let resizeTag = true
    window.onresize = () => {
      if (resizeTag) { //防抖动
        that.ifmove();
        resizeTag = false
        setTimeout(() => {
          resizeTag = true
        }, 1000)
      }
    }
    that.ifmove();
  },
  methods: {
    ifmove() {
      this.tableMaxHeight = document.documentElement.clientHeight - 234;
      this.pageSize = parseInt((this.tableMaxHeight) / 50) || 1;
      this.getDataList()
    },
    yearsChange(val){
      this.yearsList = nearSixYearsList(val)
      this.getDataList()
    },
    getDataList() { // 获取列表数据
      this.moreSearchItem = false
      this.dataListLoading=true;
      this.$httpReq.post('/fieldApply/jzTrading/list', {
        'page': this.pageIndex,
        'rows': this.pageSize,
        'searchKey': this.form.search,
        'filter': this.form
          // this.form
      }).then(res => {
        this.tableData = res.data.rows;
        this.total = res.data.total;
        this.$refs.multipleTable.doLayout();
        this.dataListLoading=false;
      })
    },

    indexMethod(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    searchBtn() { //搜索按钮
      this.pageIndex = 1;
      this.pageSize = 10;
      this.getDataList()
    },
    refresh() { //刷新按钮
      this.pageIndex = 1;
      this.form = {
        search:'' ,//搜索框的值
        tenderProjectCode:"",
        tenderProjectName:"",
        orgName:"",
      }
      this.getDataList()

    },



    router(item,viewType){ // 跳转详情
      removeTabHandle("trading_activity_detail")
      this.$router.push({
        name:'trading_activity_detail',
        query:{
            id:item.id,
            edit:viewType
        }
      })

    },



    deleteById(item) {
      this.$confirm(`确定要删除该数据?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
      this.$httpReq.post('/cateQuestBase/delete', {
        id: item.id
      }).then(res => {
        if (res.data.code == '1') {
          this.$message({
            type: 'success',
            message: res.data.msg
          })
          this.getDataList();
        } else {
          this.$message({
            type: 'error',
            message: res.data.msg
          })
        }
      })
      })
    },
    deleteSelectItem() {
      let ids = new Array();
      this.multipleSelection.forEach(key => {
        ids.push(key.id)
      })

      if (ids != "" || ids.length > 0) {
        this.$httpReq.post('/cateQuestBase/delete', {
          idList: ids
        }).then(res => {
          if (res.data.code == '1') {
            this.$message({
              type: 'success',
              message: res.data.msg
            })
            this.getDataList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      } else {
        this.$message({
          type: 'error',
          message: "未选择删除项。"
        })
      }

    },

    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1
      this.getDataList()
    },

    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },



  }


}
</script>

<style lang="scss">
.main_center {
  .top {
    .input_title {
      display: flex;
    }

    .el-form-item {
      margin-bottom: 0;
    }
  }
}

.margin-hide {
  .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>